export const threeState = {
  grid: true,
  sceneRotation: 3,
  pause: false,
  lines: false,
  bookletOpening: 0.25,
};